import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import Enumerable from 'linq';
import { ConferenceCMSService, OrganizationService } from 'src/app/_services/generatedServices';

@Component({
  selector: 'bxl-order-complete',
  templateUrl: 'order-complete.component.html',
})
export class OrderCompleteComponent implements OnInit {
  initialized = false;
  conferenceId: string;
  homeRoute: string;
  constructor(private route: ActivatedRoute, private cmsService: ConferenceCMSService) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.conferenceId = params.get('conferenceSlug');
      this.cmsService.getWebsitePagesForConference(this.conferenceId).subscribe((pages) => {
        var page = Enumerable.from(pages)
          .where((x) => x.elements.find((x) => x.pageElementType.toString() == 'ProductListing') != null)
          .firstOrDefault();
        this.homeRoute = page.slug;
        this.initialized = true;
      });
    });
  }
}
